import Log from '$lib/logging/Log';
import eventCategories from '$lib/data/event-categories';
import type { PageLoad } from './$types';
import { VivenuClient } from '$lib/vivenu/client';
import { error } from '@sveltejs/kit';

export const load = (async ({ params, fetch }) => {
	const category = eventCategories.find((category) => category.id === params.slug);
	if (!category) throw error(404, 'Not found');

	const visibleInListing = {
		visible_only: true,
		hidden_only: false,
		all: undefined
	}[category.listing_mode];

	const vivenu = new VivenuClient(fetch);
	const { data, error: err } = await vivenu.core.events.getPublicListings(visibleInListing);
	if (err) {
		Log.warning('Could not fetch public event listings', { error });
	}

	const filteredEvents = data?.filter((evt) =>
		(evt.meta?.url_slug || '').split('|').includes(category.id)
	);

	return {
		category,
		events: filteredEvents
	};
}) satisfies PageLoad;
